/**
 * Styled Components - Created by david on 27/03/18.
 */
import styled from 'styled-components'

interface DivProps {
  customCss?: string
}

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  font-family: Avenir;
`

export const CustomButton = styled.div`
  border: 1px solid gray;
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
  ${({ customCss }: DivProps) => customCss ? customCss : ''}
`

export const LogoIcon = styled.img`
  object-fit: contain;
  max-height: 28px;
  height: 100%;
  border-radius: 3px;
  margin-right: 12px;
  margin-left: -22px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/Widget/styledComponents.tsx